import { useCallback, useRef, useState } from "react"

export function useDateObserver(messagesContainer: React.RefObject<HTMLDivElement | null>) {
  const observer = useRef<IntersectionObserver | null>(null)
  const messageElements = useRef<HTMLElement[]>([])
  const [visibleDate, setVisibleDate] = useState<string | null>(null)

  const initObserver = useCallback(() => {
    if (!messagesContainer.current) return
    observer.current?.disconnect()

    observer.current = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((e) => e.isIntersecting)
        if (!visible.length) return
        const topMsg = visible.reduce((prev, curr) => (curr.boundingClientRect.top < prev.boundingClientRect.top ? curr : prev))
        const date = (topMsg.target as HTMLElement).dataset.date
        if (date && date !== visibleDate) setVisibleDate(date)
      },
      { root: messagesContainer.current, threshold: 0.1 }
    )

    messageElements.current = Array.from(messagesContainer.current.querySelectorAll("[data-date]")) as HTMLElement[]
    messageElements.current.forEach((el) => observer.current?.observe(el))
  }, [messagesContainer, visibleDate])

  const refreshObserver = useCallback(() => requestAnimationFrame(initObserver), [initObserver])

  return { visibleDate, refreshObserver }
}
